import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import 'react-tabs/style/react-tabs.css'

import SwipeableEdgeDrawer from '../SwipeableEdgeDrawer/SwipeableEdgeDrawer'
import Toolbar from './Toolbar'
import Heading from '../Heading/Heading'
import { isMobile } from '../../helpers/isMobile'
import * as Styled from './styles'
import { setIsMobileDrawerOpen } from '../../store/ui/uiSlice'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { useConfiguratorContext } from '@augmatica/iframe-interface-react'

const ToolbarContainer: React.FC = () => {
  const configurator = useConfiguratorContext()
  const { content } = useAppSelector((state) => state.init)
  const { hasBeenFulfilled_fetchPrices_aggregated } = useAppSelector((state) => state.requests)
  const { isMobileDrawerOpen, isSummaryPreviewExpanded } = useAppSelector((state) => state.ui)
  const dispatch = useAppDispatch()

  if (isMobile()) {
    if (!configurator.ready || !hasBeenFulfilled_fetchPrices_aggregated || isSummaryPreviewExpanded) return
    return (
      <SwipeableEdgeDrawer
        open={isMobileDrawerOpen}
        onOpen={() => dispatch(setIsMobileDrawerOpen(true))}
        onClose={() => dispatch(setIsMobileDrawerOpen(false))}
      >
        <Toolbar />
      </SwipeableEdgeDrawer>
    )
  } else {
    return (
      <Styled.ToolbarContainer>
        {configurator.ready && hasBeenFulfilled_fetchPrices_aggregated ? (
          <>
            <Heading level={1} className="toolbar-heading">
              {content?.other?.toolbarHeading}
            </Heading>
            <Toolbar />
          </>
        ) : (
          <>
            {/* Heading */}
            <Skeleton count={1} style={{ width: '80%', height: '50px', marginTop: '15px' }} />
            {/* Toolbar tab icons */}
            <Skeleton count={1} style={{ width: 'calc(100% - 2 * 20px)', height: '60px', margin: '25px 20px' }} />
            {/* "Storlek" heading */}
            <Skeleton count={1} style={{ width: '110px', height: '45px', margin: '20px 25px' }} />
            {/* "Bredd"/"Längd" dropdowns */}
            <Skeleton count={2} style={{ width: '210px', height: '60px', margin: '20px 25px' }} />
            {/* "Byggnadsarea" */}
            <Skeleton count={1} style={{ width: '180px', height: '25px', marginLeft: '25px' }} />
          </>
        )}
      </Styled.ToolbarContainer>
    )
  }
}

export default ToolbarContainer
